import { Box, Drawer, IconButton, Stack, Toolbar } from "@mui/material";
import {
  ChevronsLeft as CollapseIcon,
  ChevronsRight as ExpandIcon,
} from "lucide-react";
import { Link } from "react-router-dom";

import logo from "assets/icons/logo.svg";
import BackgroundPatternImage from "assets/images/background-pattern.png";

import SidebarMenu from "./SidebarMenu";

interface DesktopSidebarProps {
  width: number;
  collapsed: boolean;
  onToggleCollapse: () => void;
}

const DesktopSidebar = ({
  width,
  collapsed,
  onToggleCollapse,
}: DesktopSidebarProps) => {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width,
        "& .MuiDrawer-paper": {
          width,
          transition: "width 0.2s ease-out",
          overflow: "hidden",
          border: "none",
          backgroundColor: "brandBackground.secondary",
          boxShadow: "none",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${BackgroundPatternImage})`,
            backgroundPosition: "center center",
            backgroundRepeat: "repeat",
            opacity: 0.02,
            pointerEvents: "none",
          },
        },
      }}
    >
      <Stack height="100%">
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: collapsed ? "center" : "space-between",
            width: "100%",
            // px: collapsed ? 0 : 2,
            px: 2,
          }}
        >
          {!collapsed && (
            <Stack
              component={Link}
              to="/credit-evaluations"
              direction="row"
              alignItems="center"
              sx={{ textDecoration: "none" }}
            >
              <Box
                component="img"
                alt="Logo"
                src={logo}
                sx={{
                  height: 28,
                  width: "auto",
                  objectFit: "contain",
                  filter: "brightness(0) invert(1)",
                }}
              />
            </Stack>
          )}
          <IconButton
            onClick={onToggleCollapse}
            size="small"
            sx={{
              color: "#ABB3B2",
              "&:hover": { color: "#fff" },
            }}
          >
            {collapsed ? <ExpandIcon size={18} /> : <CollapseIcon size={18} />}
          </IconButton>
        </Toolbar>
        <SidebarMenu collapsed={collapsed} />
      </Stack>
    </Drawer>
  );
};

export default DesktopSidebar;
